<template>
    <div id="classask"
         class="error-task">
        <div class="header-wrap">
            <div class="header">
                <span class="left"
                      @click="back"><i class="icon-fanhui"></i></span>
                第{{qnumber}}题
            </div>
        </div>
        <div v-if="loading">
            <div class="nodata"
                 v-if="Object.keys(questions).length=='0'">
                <span class="icon-meiyoufabushijuan"></span>
                <p>没有作业数据</p>
            </div>
            <div class="wrap"
                 v-else>
                <div class="question stu_dowork_line"
                     v-show="questions">
                    <p class="title"
                       v-if="questions.type!=8 && questions.content">
                        <!--<span class="order">{{number}}</span>-->
                        <span v-html="questions.content"></span>
                    </p>
                    <p class="title"
                       v-else-if="questions.type==8 && questions.article_text"><span v-html="questions.article_text"></span></p>

                    <div class="img-wrap"><img :src="questions.image"
                             v-if="questions.image && questions.image.url" /></div>

                    <div class="ask"
                         v-for="ask in questions.asks">

                        <!-- 选择题 -->
                        <div class="choose"
                             v-if="ask.type==1||ask.type==8||ask.type==7">
                            <choice :ask='ask'
                                    :type="ask.type"
                                    :mystatus='1'></choice>
                        </div>
                        <!-- 填空 -->
                        <div v-if='ask.type == 2'>
                            <blanks :ask='ask'></blanks>
                        </div>
                        <!-- 主观题 -->
                        <div v-if='ask.type == 3'>
                            <!--<subjective :ask='data.asks' :index='inx' :ask='ask' :askLength='data.asks.length'></subjective>-->
                        </div>
                        <!-- 连线题 -->
                        <div class="line"
                             v-if="ask.type==4">
                            <!-- <line :ask='ask' :sheet="a.right_answer" :result="a.user_result" :onlyshow='true' :tag='1'></line> -->
                            <lines :ask='ask'
                                   :sheet="ask.right_answer"
                                   :onlyshow='false'
                                   :askLength='questions.asks.length'></lines>
                        </div>
                        <!-- 排序题 -->
                        <div class="line"
                             v-if="ask.type==5">
                            <makes :ask='ask'
                                   :is_answer="true"
                                   :type='ask.type'></makes>
                        </div>
                        <!-- 断句题 -->
                        <div v-if="ask.type==6">
                            <sentence :ask='ask'></sentence>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="wrong_names">
                <div class="content"
                     v-if="wrong_names.length">
                    <div class="title">答错<span>{{wrong_names.length}}</span>人</div>
                    <div class="name">
                        <span v-for="name in wrong_names">{{name}}</span>
                    </div>
                </div>
                <div class="content"
                     v-else>
                    <div class="title">答错<span>0</span>人</div>
                    <div class="name">
                        <span v-for="name in wrong_names"></span>
                    </div>
                </div>
            </div>
            <!-- <div class="nodata" v-if="wrong_names && !wrong_names.length">
          <span class="icon-meiyoufabushijuan"></span>
          <p>没有试题错误统计</p>
        </div>
        <div v-else>
          <div class="content" v-if="wrong_names && wrong_names.length">
            <div class="title">答错<span>{{wrong_names.length}}</span>人</div>
            <div class="name">
              <span v-for="name in wrong_names">{{name}}</span>
            </div>
          </div>
        </div>-->
        </div>
        <template v-else>
            <loadingS></loadingS>
        </template>
    </div>
</template>

<script type="text/ecmascript-6">
/**
 * 1选择，2填空，3判断，4连线，5：排序题，6断句题，7：解答题
 */
import loadingS from 'COMPONENTS/base/tealoading.vue';
import choice from 'VIEWS/chinese/module/result_choose.vue'  //选择题
import blanks from 'VIEWS/chinese/module/result_fill.vue'  //填空题
import lines from 'VIEWS/chinese/module/result_line.vue';     //连线题
import sentence from 'VIEWS/chinese/module/result_sentence.vue';//断句题
import makes from 'VIEWS/chinese/module/result_make.vue';//排序题
export default {
    data () {
        return {
            classid: this.$route.params.classid,
            taskid: this.$route.params.taskid,
            qid: this.$route.query.qid,
            askid: this.$route.query.askid,
            qnumber: this.$route.query.qnumber,
            //qnumber:this.$route.params.qnumber.slice(0,1),
            //number:this.$route.params.qnumber.slice(1),
            wrong_names: [],
            questions: [],
            loading: false
        }
    },
    methods: {
        back () {
            this.$router.go(-1)
        },
    },
    created () {
        //this.questions=null;
        this.$http.post(API_URL_TASK_API + '/chinese/check/question/task/wrong_report', {
            "message_id": this.taskid,
            "unit_class_id": this.classid,
            "ask_id": this.askid,
            "qid": this.qid
        }).then(res => {
            res = res.data;
            this.loading = true;
            if (res.response == "ok") {
                this.wrong_names = res.data.wrong_stu
                this.questions = res.data.question_data;
                //this.qnumber=this.questions[0].asks[0].number;
            }
        });
    },
    destroyed () {
    },
    components: {
        loadingS,
        sentence,
        choice,
        blanks,
        lines,
        makes
    }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";

.error-task {
    min-height: 100vh;
    .header {
        background: #5e89ef;
        .left {
            display: block;
            width: 79px / $ppr;
            height: 96px / $ppr;
            background: url(../img/choose_back.png) no-repeat center;
            background-size: 0.45rem 0.85rem;
            position: absolute;
            top: 0;
            left: 0;
        }
    }
}

.content {
    background-color: $c-fbg;
    .title {
        height: 82px / $ppr;
        line-height: 82px / $ppr;
        font-size: 36px / $ppr;
        padding: 0 $w;
        border-bottom: 1px / $ppr solid $line;
        font-weight: 600;
        span {
            // color:red;
        }
    }
    .name {
        padding: $w $w;
        display: flex;
        display: -webkit-flex;
        flex-wrap: wrap;
        -webkit-flex-wrap: wrap;
        min-height: 200px / $ppr;
        span {
            width: 25%;
            font-size: 30px / $ppr;
            color: #333;
            margin: 12px / $ppr 0;
            @include ellipsis;
        }
    }
}

/*.nodata{
    color: $c-light;
    margin-top:50px/$ppr;
		margin-bottom: 50px/$ppr;
    text-align: center;
    span{
      display: inline-block;
      color: $c-litgray;
      font-size:110px/$ppr;
      margin-bottom:36px/$ppr;
    }
  }*/
.question {
    // font-family:Monospace;
    .order {
        color: $c-theme;
    }
    .title {
        background-color: $c-fbg;
        //border-bottom: 1px/$ppr solid $line;
        padding: $w $w;
    }
    .img-wrap {
        display: flex;
        display: -webkit-flex;
        flex-wrap: wrap;
        -webkit-flex-wrap: wrap;
        justify-content: center;
        -webkit-justify-content: center;
        img {
            display: inline-block;
        }
    }
    .ask {
        margin-bottom: $w;
        background-color: $c-fbg;
    }
    .subtitle-wrap {
        border-bottom: 1px / $ppr solid $line;
    }
    .subtitle {
        padding: $w $w;
    }
    .option {
        padding: $w $w;
        border-bottom: 1px / $ppr solid $line;
        display: flex;
        display: -webkit-flex;
        flex-wrap: wrap;
        -webkit-flex-wrap: wrap;
        .spot {
            display: block;
            width: $w * 2;
            height: $w * 2;
            line-height: $w * 2;
            text-align: center;
            border: 1px / $ppr solid $line;
            border-radius: $w;
            margin-right: $w;
        }
    }
    .checked {
        color: #66cc22 !important;
        .spot {
            background-color: #66cc22 !important;
            border: 1px / $ppr solid #66cc22 !important;
            color: #fff;
        }
    }
}

.question .option:last-child {
    border: 0 !important;
}
</style>
